export default "__VITE_ASSET__BbNj7AK2__"